import React from "react";
import { Container, Grid, Img } from "./styles";
import FormLogin from "./Form";
import Logo from "assets/images/modulocker.png";

const Login = (): JSX.Element => {
  return (
    <Container container spacing={4}>
      <Grid
        item
        xs={12}
        md={7}
        style={{ display: "flex", justifyContent: "flex-start" }}
      >
        <Img src={Logo} alt="Logo" />
      </Grid>

      <Grid item xs={12} md={4}>
        <FormLogin />
      </Grid>
    </Container>
  );
};

export default Login;
